export const SN_RECENTLY_VIEWED = 'recently-viewed'
export const RECENTLY_VIEWED_ADD_ITEM = SN_RECENTLY_VIEWED + '/ADD'
export const RECENTLY_VIEWED_LOAD = SN_RECENTLY_VIEWED + '/LOAD'
